const M = [
  {
    name: "recharge",
    zh: "充值",
    en: "Recharge"
  },
  {
    name: "withdraw",
    zh: "提现",
    en: "Withdraw"
  },
  {
    name: "transfer",
    zh: "转账",
    en: "Fund transfer"
  },
  {
    name: "bankCard",
    zh: "银行卡",
    en: "Bank account"
  },
  {
    name: "reservationHandleCard",
    zh: "预约办卡",
    en: "Reservation handle card"
  },
  {
    name: "cancelReservation",
    zh: "取消预约",
    en: "Cancel the reservation"
  },
  {
    name: "billDetail",
    zh: "账单明细",
    en: "Bills detail"
  },
  {
    name: "balanceRecharge",
    zh: "余额充值",
    en: "Cash in"
  },
  {
    name: "walletRechargeSelectAmount",
    zh: "钱包充值（选择金额）",
    en: "Wallet recharge (select amount)"
  },
  {
    name: "selectOpeningBank",
    zh: "请选择开户行",
    en: "please select the opening bank"
  },
  {
    name: "openingBank",
    zh: "开户行",
    en: "Bank branches"
  },
  {
    name: "accountNumber",
    zh: "账户名称",
    en: "Account name"
  },
  {
    name: "bankCardNumber",
    zh: "银行卡号",
    en: "Bank account"
  },
  {
    name: "rechargeAmount",
    zh: "充值金额",
    en: "Cash in"
  },
  {
    name: "additionalCode",
    zh: "附加码",
    en: "Additional code"
  },
  {
    name: "completePayment",
    zh: "我已完成支付",
    en: "Done"
  },
  {
    name: "successfullySubmitted",
    zh: "提交成功",
    en: "Succeed"
  },
  {
    name: "rechargeType",
    zh: "充值方式",
    en: "Recharge type"
  },
  {
    name: "topUpTips",
    zh: "您的充值已提交，请您耐心等待客服人员将在30分钟内审核完成您的充值",
    en:
      "your load has been submitted, please wait customer service will review and complete your transaction within 30 minutes"
  },
  {
    name: "lastFourDigits",
    zh: "尾号",
    en: "Last four digits "
  },
  {
    name: "selectBankCard",
    zh: "选择银行卡",
    en: "Select bank card"
  },
  {
    name: "reservationHandleCardTips",
    zh: "提交审核后请保持手机畅通，注意接收预约专员的短信或来电",
    en:
      "Keep your phone unblocked after submitting the audit, and pay attention to receive SMS or calls from the appointment specialist"
  },
  {
    name: "sureCancelReservation",
    zh: "确定取消预约吗？",
    en: "Are you sure about the cancellation?"
  },
  {
    name: "telephoneReservation",
    zh: "电话预约",
    en: "Telephone reservation"
  },
  {
    name: "weChatReservation",
    zh: "微信预约",
    en: "WeChat reservation"
  },
  {
    name: "quickReservation",
    zh: "一键预约",
    en: "Quick reservation"
  },
  {
    name: "quickScreen",
    zh: "快捷筛选",
    en: "Quick filter"
  },
  {
    name: "transactionType",
    zh: "交易方式",
    en: "Transaction type"
  }
];

export default M;
